<template>
  <section id="dataselector" :class="$conf.sidebar.enabled ? '' : 'on-edge'">
    <b-dropdown
      id="tileset-selector"
      v-if="tileSetCount > 0"
      v-model="checkedTileSet"
      aria-role="list">
      <button
        class="button is-dark has-background-black-bis"
        type="button"
        slot="trigger">
        <span>{{ checkedTileSet }}</span>
        <b-icon icon="menu-down"></b-icon>
      </button>
      <b-dropdown-item
        v-for="item in tileSets"
        :value="item"
        :key="item"
        aria-role="listitem"
        @click="tileSetChanged">
        {{ item }}
      </b-dropdown-item>
    </b-dropdown>
    <b-dropdown
      id="property-selector"
      v-if="propertyCount > 1"
      v-model="checkedProperty"
      aria-role="list">
      <button
        class="button is-dark has-background-black-bis"
        type="button"
        slot="trigger">
        <span>{{ checkedProperty }}</span>
        <b-icon icon="menu-down"></b-icon>
      </button>
      <b-dropdown-item
        v-for="item in properties"
        :value="item"
        :key="item"
        aria-role="listitem"
        @click="propertyChanged">
        {{ item }}
      </b-dropdown-item>
    </b-dropdown>
  </section>

</template>

<script>

import log from 'util/log'

export default {
  data () {
    return {
      tileSets: this.$conf.tilesets.layers || [],
      checkedTileSet: this.$conf.tilesets.layers[0] || '',
      properties: this.$conf.tilesets.properties || [],
      checkedProperty: this.$conf.tilesets.properties[0] || ''
    }
  },
  computed: {
    tileSetCount () { return this.tileSets.length },
    propertyCount () { return this.$conf.tilesets.properties.length }
  },
  mounted () {
    if (this.$conf.tilesets.layers.length) {
      this.tileSetChanged()
    }
    if (this.$conf.tilesets.properties.length) {
      this.propertyChanged()
    }
  },
  methods: {
    tileSetChanged: function (a, b) {
      const oldSelection = this.$store.getters['tileSetConf']
      if ((oldSelection && oldSelection.id !== this.checkedTileSet) || !oldSelection) {
        this.$store.dispatch('loadTileSetConf', this.checkedTileSet)
      }
    },
    propertyChanged: function () {
      const oldSelection = this.$store.getters['tileSetProperty']
      if (oldSelection !== this.checkedProperty) {
        this.$store.dispatch('changeTileSetProperty', this.checkedProperty)
      }
    }
  }
}

</script>

<style lang="stylus">

section#dataselector
  position: fixed
  white-space: nowrap
  left: 10px
  top: 10px
  transition: 0.35s
  font-size: 0
  z-index: 1004
  >.dropdown
    display: inline-block
    margin-left: 0
  >.dropdown:not(:only-child)
    .dropdown-trigger button
      border-radius: 0
      border-left: 1px solid #7a7a7a
    &:first-child button
      border-top-left-radius: 4px
      border-bottom-left-radius: 4px
      border-left-color: transparent
    &:last-child button
      border-top-right-radius: 4px
      border-bottom-right-radius: 4px

@media (min-width: 768px)
  section#dataselector
    position: absolute
    left: 385px
    top: 10px
    width: auto
    &.on-edge
      left: 360px


</style>
